// extracted by mini-css-extract-plugin
module.exports = {"mediaSmBreakpoint":"768px","mediaMdBreakpoint":"992px","header":"Header_header__MbTxY","menu":"Header_menu__11t9R","logo":"Header_logo__3yB-7"};